import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProduto, IProdutoClienteAndTipoConsumo } from '../../models/'

interface IProdutoState {
    produtos: IProduto[]
    produtoSelecionado?: IProduto
    produtosTipoConsumo: IProdutoClienteAndTipoConsumo[]
}

const initialState: IProdutoState = {
    produtos: [],
    produtosTipoConsumo: []
}

const produtoSlice = createSlice({
    name: 'Produto',
    initialState,
    reducers: {
        setProdutoState(state, action: PayloadAction<IProduto>) {
            state.produtoSelecionado = action.payload
        },
        resetVendedoresState(state) {
            state.produtos = initialState.produtos
        },
        setProdutosTipoConsumoState(state, action: PayloadAction<IProdutoClienteAndTipoConsumo[]>) {
            state.produtosTipoConsumo = action.payload
        },
        resetProdutosTipoConsumoState(state) {
            state.produtosTipoConsumo = initialState.produtosTipoConsumo
        }
    }
})

export const {
    resetProdutosTipoConsumoState,
    resetVendedoresState,
    setProdutoState,
    setProdutosTipoConsumoState
} = produtoSlice.actions

export const produtoReducer = produtoSlice.reducer 